import {Backend} from '@/_axios';

export default {
  list(page) {
    return Backend.get('/languages/', {params: {page}});
  },
  classifier() {
    return Backend.get('/languages/list/');
  },
  createData() {
    return Backend.get('/languages/create');
  },
  editData(id) {
    return Backend.get(`/languages/${id}/edit`);
  },
  create(data) {
    return Backend.post('/languages/', data);
  },
  update(data) {
    return Backend.put(`/languages/${data.id}`, data);
  },
  delete(id) {
    return Backend.delete(`/languages/${id}`);
  },
  importTranslations(id, data) {
    return Backend.patch(`/languages/${id}/translations/import`, data);
  },
  exportTranslations(id) {
    return Backend.get(`/languages/${id}/translations/export`);
  },
};
